const PlusIcon: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.50696 0.00317383V4.50415H10.0079V5.50604H5.50696V10.007H4.50507V5.50604H0.00408936V4.50415H4.50507V0.00317383H5.50696Z"
      fill="#202327"
    />
  </svg>
);

export default PlusIcon;
